export const jwt = {
    JWT_KEY: 'X_REG_ACCESS_TOKEN',
    THEME_MODE: 'THEME_MODE'
}